<script lang="ts">
import type { RangeCalendarGridRowProps } from '..'
import { RangeCalendarGridRow } from '..'

export interface DateRangePickerGridRowProps extends RangeCalendarGridRowProps {}
</script>

<script setup lang="ts">
const props = defineProps<DateRangePickerGridRowProps>()
</script>

<template>
  <RangeCalendarGridRow v-bind="props">
    <slot />
  </RangeCalendarGridRow>
</template>
